import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { siteConfig } from '@/config/site'
import { sendGa4SpaPageView } from '@/lib/google-tags'

/**
 * Fires GA4 `page_view` on React Router navigations when using direct gtag (no GTM).
 * Initial page load is handled in `initGoogleTags`.
 */
export const GoogleAnalyticsSpaTracker = () => {
  const { pathname, search, hash } = useLocation()
  const skipNext = useRef(true)

  useEffect(() => {
    if (siteConfig.gtmContainerId.trim()) return
    const ga = siteConfig.gaMeasurementId.trim()
    if (!ga) return

    const pagePath = `${pathname}${search}${hash}`
    if (skipNext.current) {
      skipNext.current = false
      return
    }
    sendGa4SpaPageView(ga, pagePath)
  }, [pathname, search, hash])

  return null
}
